import { MetricsKind } from "helpers/metrics/types";
import { RowComputeParams } from "./types";
import { sum } from "./sum";
import { roundValue } from "lib/number";
import { getColumnTotalUnit } from "./formula-units";

export const UNIT_ROW_PERCENTAGE_PLAN = (params: RowComputeParams) => {
    const { mainRowNodes, getterParams, gridViewRef, mainGridApi } = params;

    const unitsValues = gridViewRef.current.getMetricValuesForRows(
        getterParams.column.getColId(),
        MetricsKind.UNITS,
        mainRowNodes
    );

    const rowsTotalUnits = sum(unitsValues);

    // Bail out sooner. No point doing heavy calculation of the whole rows if current value is 0.
    if (rowsTotalUnits === 0) {
        return 0;
    }

    const totalUnits = getColumnTotalUnit(mainGridApi, gridViewRef, getterParams.column.getColId());

    return totalUnits > 0 ? roundValue((rowsTotalUnits / totalUnits) * 100) : 0;
};
